<!--
 * @Author: AI Assistant
 * @Description: 敏感字段全局状态管理Provider，管理同一时刻仅一个小眼睛打开的全局状态
 * @FilePath: /src/components/global/SensitiveFieldProvider.vue
-->
<template>
  <slot />
</template>

<script lang="ts" setup>
import { provide, ref, reactive, computed } from 'vue'
import { useRoute } from 'vue-router'

export interface SensitiveFieldContext {
  /** 当前活跃的脱敏字段唯一标识（null 表示全部关闭） */
  activeFieldKey: string | null
  /** 切换小眼睛状态：打开新的、关闭旧的 */
  toggleField: (fieldKey: string) => void
  /** 关闭当前活跃字段 */
  closeActiveField: () => void
  /** 当前菜单名称 */
  menuName: string
}

const props = defineProps<{
  /** 覆盖菜单名称，不传则取 route.meta.title */
  menuName?: string
}>()

const route = useRoute()

/** 从路由meta获取菜单名称 */
const effectiveMenuName = computed(() => {
  return props.menuName || (route.meta?.title as string) || ''
})

/** 当前活跃的脱敏字段唯一标识 */
const activeFieldKey = ref<string | null>(null)

/** 切换小眼睛状态 */
const toggleField = (newFieldKey: string) => {
  activeFieldKey.value = newFieldKey
}

/** 关闭当前活跃字段 */
const closeActiveField = () => {
  activeFieldKey.value = null
}

/** 提供全局上下文 */
provide<SensitiveFieldContext>('sensitiveFieldContext', reactive({
  activeFieldKey,
  toggleField,
  closeActiveField,
  menuName: effectiveMenuName.value
}))
</script>
